export default (ctx, html) => html`
<button
  @click="${ctx.navigate}"
  class="${ctx.isBold ? 'font-weight-bold' : ''}"
  style="background-color:${ctx.color}; color:${ctx.textColor}">
  <span>${ctx.content}</span>
</button>
`;
